import type { HTMLAttributes } from "react";
import "./keybind-v2.css";

export interface KeybindV2Props extends HTMLAttributes<HTMLDivElement> {
  keys: readonly string[];
  variant?: "neutral" | "ghost";
}

export function KeybindV2({ keys, variant = "neutral", className, ...props }: KeybindV2Props) {
  return (
    <div
      {...props}
      data-component="keybind-v2"
      data-variant={variant}
      className={className}
    >
      {keys.map((key, i) => (
        <div key={i} data-slot="keybind-v2-key">
          <span data-slot="keybind-v2-label">{key}</span>
        </div>
      ))}
    </div>
  );
}
